import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarFull = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 0C4.44688 0 4 0.446875 4 1V2H3C1.89688 2 1 2.89687 1 4V5.5H15V4C15 2.89687 14.1031 2 13 2H12V1C12 0.446875 11.5531 0 11 0C10.4469 0 10 0.446875 10 1V2H6V1C6 0.446875 5.55312 0 5 0ZM1 7V13C1 14.1031 1.89688 15 3 15H13C14.1031 15 15 14.1031 15 13V7H1Z",
		fill: "#001432"
	})
});
export default SvgCalendarFull;
